module.exports = __webpack_public_path__ + "static/media/telegram.cf75da71.svg";